(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order-sum.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order-sum.js');
"use strict";


const {
  TableRow,
  TableCell
} = svs.ui.reactTable;
const {
  SUM,
  SEK
} = svs.ticket_partner.myOrders.constants.TEXTS.TABLE_FOOTER;
const OrderSum = _ref => {
  let {
    batches
  } = _ref;
  const sum = batches === null || batches === void 0 ? void 0 : batches.reduce((acc, _ref2) => {
    let {
      numberOfVouchers,
      singleVoucherValue
    } = _ref2;
    return numberOfVouchers * singleVoucherValue + acc;
  }, 0);
  return React.createElement(TableRow, {
    footer: true
  }, React.createElement(TableCell, {
    className: "sum-align",
    colspan: "4"
  }, React.createElement("span", {
    className: "f-bold"
  }, SUM, "\xA0", svs.utils.format.Currency(sum), "\xA0", SEK)));
};
svs.ticket_partner.myOrders.components.OrderSum = OrderSum;

 })(window);